// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        //is explorer
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        let scrollParallax = []
        let scrolled = 0

        // screen height
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
            //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }
        
        if (document.getElementById('terms_btn')) {
            let btnTerms = document.getElementById('terms_btn');
            let termsInfo = document.getElementById('terms_info');
            let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
            btnTerms.addEventListener('click', function(e) {
                e.preventDefault();
                termsInfo.classList.toggle('open');
                if (!this.classList.contains('active')) {
                    this.classList.add('active');
                    termsInfo.style.height = termsInfoHeight + 'px';
                } else {
                    this.classList.remove('active');
                    termsInfo.style.height = '0px';
                }
            });
        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/
    }

    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    if(textModule){
        textModule.forEach(function(text_module) {
            text_module.classList.add('animate-fade', 'top');
        });
    }

    let Body = document.body;
    let BurgerMenu = document.getElementById('js_btn_menu');
    let NavigationBox = document.getElementById('navigationBox');
    let Header = document.getElementById('header');

    if(BurgerMenu){
        BurgerMenu.addEventListener('click', function(e){
            e.preventDefault();
            if(this.classList.contains("open")){
                this.classList.remove('open');
                this.querySelector('.text').textContent = 'Menu';
                NavigationBox.classList.remove('open');
                Body.classList.remove('scroll-no');
                Header.classList.remove('open');
            } else {
                this.classList.add('open');
                this.querySelector('.text').textContent = 'Close';
                NavigationBox.classList.add('open');
                Body.classList.add('scroll-no');
                Header.classList.add('open');
            }
        });
    }

    let BtnBook = document.getElementById('js_btn_book');
    let BookingBox = document.getElementById('bookBox');
    let BookClose = document.getElementById('js_book_close');

    if(BtnBook){
        BtnBook.addEventListener('click', function(e){
            e.preventDefault();
            BookingBox.classList.add('open');
            Body.classList.add('scroll-no');
        });
    }

    if(BookClose){
        BookClose.addEventListener('click', function(e){
            e.preventDefault();
            BookingBox.classList.remove('open');
            Body.classList.remove('scroll-no');
        });
    }

    document.addEventListener('DOMContentLoaded', () => {

        // Main Nav Dropdown
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.classList.add('li-sub');
					primary_nav.querySelector('a').addEventListener("click", (event) => {
						event.preventDefault();
					});
                    primary_nav.classList.add('li-submenu');
                    let liHeight = primary_nav.nextElementSibling.querySelector('a').clientHeight+26;
                    let ulHeight = primary_nav.querySelector('ul.submenu').clientHeight+liHeight;
                    primary_nav.style.height = liHeight+'px';
                    primary_nav.addEventListener("mouseover", (event) => {
                        primary_nav.querySelector('a').classList.add('open');
                        if(primary_nav.querySelector('ul.submenu')){
                            primary_nav.style.height = ulHeight+'px';
                        }
                    });
                    primary_nav.addEventListener("mouseout", (event) => {
                        primary_nav.querySelector('a').classList.remove('open');
                        if(primary_nav.querySelector('ul.submenu')){
                            primary_nav.style.height = liHeight+'px';
                        }
                    });
                }
            });
        }

        $('#arriveInput').on('change', function(){
            start = $(this).val();
            $('.calendar-block').datepicker("setDate", start);
            $(this).attr('value', start);
        });

        $('#departureInput').on('change', function(){
            end = $(this).val();
            $('.calendar-home, .calendar-block').datepicker("setDate", end);
            $(this).attr('value', end);
        });

        $("#closeFake, #adults_home").click(function(){
            $('#fakeInput').fadeOut();
        })

        $('.calendar-block').datepicker({
            changeMonth: false,
            dateFormat: 'yy-mm-dd',
            numberOfMonths: 2,
            beforeShowDay: function (date) {
                $.datepicker._defaults.dateFormat = "yy-mm-dd";
                //console.log(date,date.getTime(),start,end);
                let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
                let endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
                if (date.getTime() == startDate.getTime()) {
                    return [true, "startday"];
                } else {
                    if (date.getTime() == endDate.getTime()) {
                        return [true, "endday"];
                    } else {
                        if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
                            return [true, "days"];
                        } else {
                            return [true, ""];
                        }
                    }
                }
            },
            onSelect: function (date) {
                let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
                let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
                let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

                if (opened == 0) {
                    opened = 1;
                    start = date;
                    end = date;
                    opencheck = 0;
                } else {
                    opened = 0;
                    if (selectedDate <= arrive) {
                        end = start;
                        start = date;
                    } else {
                        end = date;
                    }
                    $('#fakeInput').fadeOut();
                    opencheck = 1;
                    firstClick = 0;
                }

                $('#arriveInput').attr('value', start);
                $('#departureInput').attr('value', end);
                $('#arrive_depart').attr('value', start + ' - ' + end);

            },
            onChangeMonthYear: function () {
                opencheck = 1;
            }
        });

        $("input[name=zip_code]").attr("maxlength", "5");

    });

    window.onload = function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        })
    };

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
    if(aHref){
        aHref.forEach(function(a_href) {
            a_href.addEventListener('click', function(e){
                e.preventDefault();
                let strAnchor = this.hash.slice(1);
                animateto(strAnchor);
            });
        });
    }

    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        aBtn.forEach(function(a_btn) {
            let htmlString = a_btn.textContent;
            a_btn.innerHTML = '<span>'+htmlString+'</span><span class="arrow-btn"><svg xmlns="http://www.w3.org/2000/svg" width="4.500724792480469" height="9" viewBox="0 0 4.500724792480469 9"><path d="m3.02099609375,5.083984375c-1.006988525390625,1.02899169921875-2.014007568359375,2.058013916015625-3.02099609375,3.087005615234375l.80999755859375.829010009765625,3.188995361328125-3.26300048828125c.668975830078125-.68939208984375.668975830078125-1.785614013671875,0-2.475006103515625L.80999755859375,0l-.80999755859375.8289794921875c1.007659912109375,1.029327392578125,2.01531982421875,2.058685302734375,3.022979736328125,3.0880126953125.040435791015625.042205810546875.2362060546875.2552490234375.234222412109375.5875244140625-.001983642578125.32763671875-.19482421875.53656005859375-.2362060546875.5794677734375Z"/></svg></span>';
        });
    }

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.getElementById('home');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            entry.style.height = screenHeight+'px';
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                entry.style.height = screenHeight+'px';
            });
        });
    }

    // Switch Location Maps

    const locationMaps = document.querySelectorAll('.location-block--new .location-item');
    const locationControls = document.querySelectorAll('.location-block--new_tab');

    locationControls && locationControls.forEach(tab => tab.addEventListener('click', switchMap) );

    function switchMap() {
        locationControls.forEach(tab => tab.classList.remove('active'));
        this.classList.add('active');

        locationMaps.forEach(map => {
            if (map.dataset.tab == this.dataset.target) {
                map.classList.add('active');
            } else {
                map.classList.remove('active');
            }
        });
    }


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true
    });

    $('.reviews-slider').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        adaptiveHeight: true,
    });

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        centerMode: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    variableWidth: false,
                    slidesToShow: 1,
                    centerMode: false,
                }
            }
        ]
    });

    $('.gallery-slider-grid').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.gallery-slider-ins').slick({
        arrows: false,
        dots: true,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    fade: false,
                    variableWidth: true,
                    slidesToShow: 1,
                    centerMode: true,
                }
            }
        ]
    });

    $('.slider-bg-content').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.reviews-slides').slick({
        arrows: false,
        dots: true,
        infinite: true,
        fade: true,
    });

    $('.awards-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.images-mini').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        focusOnSelect: true
    });
    //Progressbar Header

    let timeHeader = 2;
    let $barHeader, isPauseHeader, tickHeader, percentTimeHeader, $sliDerHeader;

    $barHeader = $('.slider-progress-header .progress');
    $sliDerHeader = $('.top-img.sym-slides');
    function startProgressbarHeader() {
        resetProgressbarHeader();
        percentTimeHeader = 0;
        isPauseHeader = false;
        tickHeader = setInterval(intervalHeader, 40);
    }

    function intervalHeader() {
        if (isPauseHeader === false) {
            percentTimeHeader += 1 / (timeHeader + 0.1);
            $barHeader.css({
                height: percentTimeHeader + "%"
            });
            if (percentTimeHeader >= 100) {
                $sliDerHeader.slick('slickNext');
                startProgressbarHeader();
            }
        }
    }

    function resetProgressbarHeader() {
        $barHeader.css({
            height: 0 + "%"
        });
        clearTimeout(tickHeader);
    }

    $('.top-img.sym-slides').on('beforeChange', function(){
        startProgressbarHeader();
    });

    $('.top-img.sym-slides .slick-next, .top-img.sym-slides .slick-prev, .top-img.sym-slides .top-img.slick-dots button').click(function() {
        startProgressbarHeader();
    });
    startProgressbarHeader();

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
//ScrollW
function scrollW(){
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            // downscroll code
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
                if(document.getElementById('headerLogo')){
                    logoToggle();
                }
            }
        } else {
            // upscroll code
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
        
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
            if(document.getElementById('headerLogo')){
                logoToggle();
            }
        }
    }

    let SubMenu = document.getElementById('subMenuAnchor');
    if(SubMenu){
        let subPost = document.getElementById('subMenu');
        let subPosition = '';
        if(document.body.classList.contains('alert_open')){
            subPosition = offset(SubMenu).top - 122;
        } else {
            subPosition = offset(SubMenu).top - 78;
        }
        if(st > subPosition){
            if(!subPost.classList.contains('floating-up')){
                subPost.classList.add('floating-up');
            }
        } else {
            if(subPost.classList.contains('floating-up')) {
                subPost.classList.remove('floating-up');
            }
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function logoToggle(){
    document.getElementById('headerLogo').classList.add('changed');
    let altImg = document.getElementById('headerLogo').getAttribute('data-alt');
    let srcImg = document.getElementById('headerLogo').getAttribute('src');
    
    setTimeout(() => {
        document.getElementById('headerLogo').setAttribute('data-alt',srcImg);
        document.getElementById('headerLogo').setAttribute('src',altImg);
        document.getElementById('headerLogo').classList.remove('changed');
        if( altImg.split('/').pop() === 'logo-icon.svg'){
            document.getElementById('headerLogo').classList.add('logoIcon');
        }else{
            document.getElementById('headerLogo').classList.remove('logoIcon');
        }
    }, 300);
}